import { Component, ElementRef, ViewChildren } from '@angular/core';

import { ComponentsService } from '../../services/components.service';
import { BlueprintService } from '../../services/blueprint.service';
import { AttributeDataService } from '../../services/attribute-data.service';

@Component({
  selector: 'template-attribute-list',
  templateUrl: './template-attribute-list.component.html',
  styleUrls: ['./template-attribute-list.component.scss'],
  standalone: false,
})
export class TemplateAttributeListComponent {
  @ViewChildren('ComponentName') componentNameInputs: ElementRef[];

  constructor(
    public componentsService: ComponentsService,
    private blueprintService: BlueprintService,
    private attributeDataService: AttributeDataService,
  ) {}

  get hasUserComponents(): boolean {
    return this.attributeDataService.getUserComponents()?.length > 0;
  }

  get hasBaseComponents(): boolean {
    return (
      this.blueprintService.blueprintData?.components?.filter(
        (component) => !component.nonEditable,
      )?.length > 0
    );
  }

  get showEmptyState(): boolean {
    return !this.hasUserComponents && !this.hasBaseComponents;
  }

  showUserComponentSelector() {
    this.componentsService.editComponent(
      {
        type: 'rise-playlist-item-selector',
      },
      {
        userComponents: true,
      },
    );
  }
}
